import { j as s } from "./atoms-v218.js";
import { createContext as $, forwardRef as l, useContext as A, Fragment as g } from "react";
import { AddOns as C, AddOnsCategory as N, AddOnsCategoryName as R, AddOnsCategoryList as S, AddOnsItem as b, AddOnsItemPicture as w, AddOnsItemContent as H, HeaderWrapper as W, AddOnsItemHeader as k, AddOnsItemTitle as z, AddOnsItemSubtitle as B, AddOnsItemDescription as D, SelectedAddonsContentWrapper as E, SelectedAddonsContent as F } from "./atoms-v278.js";
import { Button as L } from "./atoms-v26.js";
import { AddOnsSkeleton as P } from "./atoms-v279.js";
import { OverflowMenu as T } from "./atoms-v229.js";
import { Icon as q } from "./atoms-v217.js";
const O = $("small"), j = l(
  ({
    children: r,
    className: t,
    id: e,
    isSkeleton: a = !1,
    skeletonCategoryCount: n,
    skeletonItemCount: i,
    variant: d = "small",
    ...m
  }, x) => a ? /* @__PURE__ */ s.jsx(
    P,
    {
      skeletonCategoryCount: n,
      skeletonItemCount: i,
      variant: d
    }
  ) : /* @__PURE__ */ s.jsx(O.Provider, { value: d, children: /* @__PURE__ */ s.jsx(C, { className: t, id: e, ref: x, ...m, children: r }) })
);
j.displayName = "AddOns";
const p = l(
  ({ children: r, className: t, id: e, name: a, ...n }, i) => {
    const d = A(O);
    return /* @__PURE__ */ s.jsxs(N, { $variant: d, className: t, id: e, ref: i, ...n, children: [
      /* @__PURE__ */ s.jsx(R, { $variant: d, children: a }),
      /* @__PURE__ */ s.jsx(S, { $variant: d, children: r })
    ] });
  }
);
p.displayName = "AddOnsCategory";
const h = l(
  ({
    action: r,
    className: t,
    description: e,
    id: a,
    isSelected: n,
    overflowMenuProps: i,
    picture: d,
    selectedAddonsContent: m,
    subtitle: x,
    title: f,
    ...u
  }, v) => {
    const o = A(O);
    return /* @__PURE__ */ s.jsxs(b, { className: t, id: a, ref: v, ...u, children: [
      /* @__PURE__ */ s.jsx(w, { aspectRatio: "1/1", ...d, width: o === "small" ? 120 : 180 }),
      /* @__PURE__ */ s.jsxs(H, { $variant: o, children: [
        /* @__PURE__ */ s.jsxs(W, { children: [
          /* @__PURE__ */ s.jsxs(k, { children: [
            /* @__PURE__ */ s.jsx(z, { $variant: o, children: f }),
            /* @__PURE__ */ s.jsx(B, { $variant: o, children: x })
          ] }),
          n && i && /* @__PURE__ */ s.jsx(T, { ...i })
        ] }),
        /* @__PURE__ */ s.jsx("div", { children: n ? /* @__PURE__ */ s.jsx(E, { children: m == null ? void 0 : m.map((c, y) => /* @__PURE__ */ s.jsxs(F, { children: [
          c.icon && /* @__PURE__ */ s.jsx(q, { name: c.icon, size: "small" }),
          c.content
        ] }, `${c.icon}-${y}`)) }) : /* @__PURE__ */ s.jsxs(g, { children: [
          o === "large" && /* @__PURE__ */ s.jsx(D, { children: e }),
          r
        ] }) })
      ] })
    ] });
  }
);
h.displayName = "AddOnsItem";
const I = l(
  ({ children: r, className: t, id: e, ...a }, n) => /* @__PURE__ */ s.jsx(L, { className: t, id: e, ref: n, ...a, variant: "text", children: r })
);
I.displayName = "AddOnsItemAction";
const X = Object.assign(j, {
  Category: p,
  Item: h,
  ItemAction: I
});
export {
  X as AddOns
};
